import { useFormikContext } from 'formik';
import { ReactElement, useMemo } from 'react';
import { RightAlignedButtons } from '../../../../../../components/button/aligned-buttons';
import { BaseButton } from '../../../../../../components/button/base-button';
import { getLocalizedText } from '../../../../../../i18n/i18n.utils';
import { useFlowServices } from '../../../hook/flow-service.hooks';
import { FlowItemForm, FlowItemSharedRef } from '../../../model/flow.types';
import { ParametersList } from '../../flow-item-parameter/parameter-list';
import { TeachOptionsBaseProps } from '../teach.types';

export interface TriggerOutputOptionsProps extends TeachOptionsBaseProps {}

const TriggerOutputOptions = (
  props: TriggerOutputOptionsProps
): ReactElement => {
  const { onAdd } = props;

  const { flowItemService, system } = useFlowServices();
  const { values } = useFormikContext<FlowItemForm>();

  const parameters = useMemo(() => {
    return flowItemService.getParametersMetadata(
      FlowItemSharedRef.TRIGGER_OUTPUT
    );
  }, [flowItemService]);

  return (
    <>
      <ParametersList parameters={parameters} system={system} />

      {typeof onAdd === 'function' && (
        <RightAlignedButtons>
          <BaseButton
            buttonProps={{
              color: 'primary',
              onClick: (e) => {
                e.preventDefault();
                if (onAdd) {
                  onAdd(flowItemService.convertFormToFlowItem(values, system));
                }
              },
            }}
          >
            {getLocalizedText('common:add')}
          </BaseButton>
        </RightAlignedButtons>
      )}
    </>
  );
};

export { TriggerOutputOptions };
